"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubEnvironmentUI = exports.isParentEnvironmentUI = exports.isNormalEnvironmentUI = exports.isSubEnvironment = exports.isParentEnvironment = exports.isNormalEnvironment = exports.FeaturePermissionLevel = exports.FeaturePermission = exports.EnvironmentUserRole = exports.ImageVariantTypes = exports.EnvironmentLanguage = void 0;
const screens_1 = require("./screens");
var EnvironmentLanguage;
(function (EnvironmentLanguage) {
    /** Finnish */
    EnvironmentLanguage["fi"] = "fi";
    /** Swedish */
    EnvironmentLanguage["sv"] = "sv";
})(EnvironmentLanguage = exports.EnvironmentLanguage || (exports.EnvironmentLanguage = {}));
var ImageVariantTypes;
(function (ImageVariantTypes) {
    ImageVariantTypes["max500"] = "max500";
    ImageVariantTypes["max1000"] = "max1000";
    ImageVariantTypes["original"] = "original";
})(ImageVariantTypes = exports.ImageVariantTypes || (exports.ImageVariantTypes = {}));
var EnvironmentUserRole;
(function (EnvironmentUserRole) {
    EnvironmentUserRole["admin"] = "admin";
    EnvironmentUserRole["user"] = "user";
})(EnvironmentUserRole = exports.EnvironmentUserRole || (exports.EnvironmentUserRole = {}));
/** Environment features that have permission levels. Can be extended in the future */
var FeaturePermission;
(function (FeaturePermission) {
    FeaturePermission["lists"] = "lists";
    FeaturePermission["templates"] = "templates";
})(FeaturePermission = exports.FeaturePermission || (exports.FeaturePermission = {}));
var FeaturePermissionLevel;
(function (FeaturePermissionLevel) {
    FeaturePermissionLevel["read"] = "read";
    FeaturePermissionLevel["write"] = "write";
})(FeaturePermissionLevel = exports.FeaturePermissionLevel || (exports.FeaturePermissionLevel = {}));
/** normal environment, not parent or sub */
exports.isNormalEnvironment = (item) => ((item === null || item === void 0 ? void 0 : item.subEnvironments) === undefined || (item === null || item === void 0 ? void 0 : item.subEnvironments) === null) &&
    !(item === null || item === void 0 ? void 0 : item.parentEnvironment);
exports.isParentEnvironment = (item) => (item === null || item === void 0 ? void 0 : item.subEnvironments) !== null && (item === null || item === void 0 ? void 0 : item.subEnvironments) !== undefined;
exports.isSubEnvironment = (item) => !!(item === null || item === void 0 ? void 0 : item.parentEnvironment);
exports.isNormalEnvironmentUI = (item) => ((item === null || item === void 0 ? void 0 : item.subEnvironments) === undefined || (item === null || item === void 0 ? void 0 : item.subEnvironments) === null) &&
    !(item === null || item === void 0 ? void 0 : item.parentEnvironment);
exports.isParentEnvironmentUI = (item) => (item === null || item === void 0 ? void 0 : item.subEnvironments) !== null && (item === null || item === void 0 ? void 0 : item.subEnvironments) !== undefined;
exports.isSubEnvironmentUI = (item) => !!(item === null || item === void 0 ? void 0 : item.parentEnvironment);
//# sourceMappingURL=environments.js.map